/**
 * Utility per gestire la navigazione basata sui ruoli utente
 * Centralizza la logica di reindirizzamento per evitare duplicazioni
 */

/**
 * Lista completa dei ruoli che usano la dashboard admin/committee
 */
export const ADMIN_ROLES = [
  'admin',
  'uisp_territorial',
  'uisp_regional',
  'uisp_national',
  'uisp_territorial_secretary',
  'uisp_regional_secretary',
  'uisp_nazionale_secretary',
  'sda_territorial',
  'sda_regional',
  'sda_nazionale',
  'cordinator_territorial',
  'cordinator_regional',
  'cordinator_nazionale'
];

/**
 * Determina il path della dashboard in base al ruolo utente
 * @param {string} role - Il ruolo dell'utente
 * @returns {string} - Il path della dashboard appropriato
 */
export const getDashboardPath = (role) => {
  if (ADMIN_ROLES.includes(role)) {
    return '/admin';
  } else if (role === 'association') {
    return '/association';
  } else {
    // Fallback per ruoli non riconosciuti
    console.warn(`Unknown role: ${role}, defaulting to login`);
    return '/login';
  }
};

/**
 * Naviga alla dashboard appropriata in base al ruolo
 * @param {object} navigate - La funzione navigate di react-router-dom
 * @param {string} role - Il ruolo dell'utente
 */
export const navigateToDashboard = (navigate, role) => {
  const path = getDashboardPath(role);
  navigate(path);
};

/**
 * Verifica se un ruolo è un ruolo admin/committee
 * @param {string} role - Il ruolo da verificare
 * @returns {boolean}
 */
export const isAdminRole = (role) => {
  return ADMIN_ROLES.includes(role);
};
